// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"d3e53c0a","785":"35739ab9","971":"c4231737"}[chunkId] + ".chunk.js";
};